import React from 'react';

const FindbarSearch = () => {
	return <div id="search_results"></div>;
};

export default FindbarSearch;
